"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactCardRoot = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _constants = require("../constants");
var _contactCardTheme = require("../contactCardTheme");
const {
  neutralLight40
} = _designTokens.lodestarColors;
const ContactCardRoot = (0, _styled.default)("span")`
    display: block;
    box-shadow: ${_ref => {
  let {
    mode,
    themeMode
  } = _ref;
  return mode === "normal" ? _contactCardTheme.contactCardTheme.shadow(themeMode) : "none";
}};
    padding: ${props => props.mode === "normal" ? 16 : 12}px;
    background-color: ${props => props.mode === "normal" ? `var(--smar--sds--contact--card--background, ${(0, _designTokensReact.color)("color--background--surfaces--body", neutralLight40)})` : "transparent"};
    border-radius: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _contactCardTheme.contactCardTheme.borderRadius(themeMode);
}};
    width: var(--smar--sds--content--card--width, 354px);

    &.${_constants.CONTACT_CARD_WITH_HEADER_CLASSNAME} {
        display: flex;
        flex-direction: column;
    }
`;
exports.ContactCardRoot = ContactCardRoot;
//# sourceMappingURL=ContactCardRoot.js.map